module.exports = __webpack_public_path__ + "static/media/delete.cf2ec641.png";